import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { IListElement, ListElementComponent } from './list-element/list-element.component';

@Component({
    selector: 'app-titled-list-group',
    templateUrl: './titled-list-group.component.html',
    styleUrls: ['./titled-list-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ListElementComponent]
})
export class TitledListGroupComponent {
    @Input()
    title?: string;

    @Input()
    items: IListElement[];

    @Output()
    isFavoriteChange: EventEmitter<IListElement>;

    @Output()
    removeItemRequest: EventEmitter<number>;

    constructor() {
        this.items = [];
        this.isFavoriteChange = new EventEmitter<IListElement>();
        this.removeItemRequest = new EventEmitter<number>();
    }

    onFavoriteChange(item: IListElement) {
        this.isFavoriteChange.emit(item);
    }

    onRemoveItem(itemId: number) {
        this.removeItemRequest.emit(itemId);
    }
}
